import { render, staticRenderFns } from "./IbxStandardTooltip.vue?vue&type=template&id=6938b56e"
import script from "./IbxStandardTooltip.vue?vue&type=script&lang=js"
export * from "./IbxStandardTooltip.vue?vue&type=script&lang=js"
import style0 from "./IbxStandardTooltip.vue?vue&type=style&index=0&id=6938b56e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports